export default {
  title: "Messaggio Chats",
  form: {
    email: {
      label: "Email",
      placeholder: "Введите Ваш email",
    },
    password: {
      label: "Password",
      placeholder: "Введите Ваш пароль",
    },
    confirmation: {
      label: 'Google Auth code',
      placeholder: 'Google Auth code',
    },
    button: {
      text: "Войти",
      text_mode_otp: "Войти",
    },
    forgotlink: "Забыли пароль?"
  },
  signuptext: "Нет аккаунта?",
  signuplink: "Создать аккаунта",
  oauth_loading: 'Загрузка OAuth...',

  errors: {
    max_rate_limiting_reached: {
      title: 'Достигнуто максимальное количество попыток, повторите попытку позже',
    },
    error403: {
      title: 'Ошибка авторизации',
      description: 'Логин или пароль указан неверно.',
    },
  },
}
